<template>
  <vs-wrapper>
    <v-col class="preview-items">
      <v-row v-if="shouldDisplayPreviewText" class="mb-1">
        <vs-text type="caption">{{ previewItemsText }}</vs-text>
      </v-row>
    </v-col>
  </vs-wrapper>
</template>

<script setup lang="ts">
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import { computed, ref, watchEffect } from 'vue'

type ItemType = { id: any; name: string; header?: any; divider?: any }

const props = withDefaults(
  defineProps<{
    items?: ItemType[]
    selected?: any[]
    valueResolver?: (id: any) => Promise<ItemType>
  }>(),
  {
    selected: () => [],
  },
)

const previewItems = ref<ItemType[]>([])

watchEffect(() => {
  if (props.items) {
    previewItems.value = props.items.filter(
      (item) => props.selected.includes(item.id) && !('header' in item || 'divider' in item),
    )
  } else if (props.valueResolver) {
    Promise.all(props.selected.map(props.valueResolver)).then((results) => {
      previewItems.value = results
    })
  }
})

const shouldDisplayPreviewText = computed(() => {
  return previewItems.value.length > 0
})

const previewItemsText = computed(() => {
  const namesOfItemsToDisplay = previewItems.value.slice(0, 3).map((item) => item.name)

  if (previewItems.value.length > 3)
    namesOfItemsToDisplay.push(`+${previewItems.value.length - 3} more`)

  return namesOfItemsToDisplay.join(', ')
})
</script>

<style scoped>
.preview-items {
  font-size: 12px;
  color: var(--color-grey--light);
  font-family: Lato, sans-serif;
  font-style: italic;
  margin-bottom: -10px;
}

.more-items {
  font-size: 12px;
  color: var(--color-grey--light);
  font-family: Lato, sans-serif;
}
</style>
